import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import TextFieldValidator from "../../../../LeaveApplication/component/Validator/TextFieldValidator";
import Grid from "@material-ui/core/Grid";
import moment from "moment-timezone";

const useStyles = makeStyles(theme => ({
    root: {
        position: "relative"
    },
    display: {
        position: "absolute",
        top: 2,
        left: 18,
        bottom: 2,
        background: "white",
        pointerEvents: "none",
        right: 50,
        display: "flex",
        alignItems: "center"
    },
    input: {},
    textField: {
        marginBottom: theme.spacing(1),
    },
    cssLabel: {
        color: "#000",
        '&.Mui-focused': {
            color: '#000'
        }
    },
}));

function InputComponent({defaultValue, inputRef, ...props}: any) {
    const classes = useStyles();
    const [value, setValue] = React.useState(() => props.value || defaultValue);

    const handleChange = event => {
        setValue(event.target.value);
        if (props.onChange) {
            props.onChange(event);
        }
    };

    return (
        <div className={classes.root}>
            <div className={classes.display}>{value}</div>
            <input
                className={classes.input}
                style={{height: '0.4em', width: 110}}
                ref={inputRef}
                {...props}
                onChange={handleChange}
                value={value}
            />
        </div>
    );
}

function CustomDateField({label, name, values, handleChange, validators, space}) {
    const classes = useStyles();
    const fieldRequired = 'this field is required'

    return (
        <Grid item xs={space}>
            <TextFieldValidator
                fullWidth
                label={label}
                id={name}
                type="date"
                onChange={handleChange}
                inputProps={{
                    name: name,
                    id: name + '-native-disabled',
                }}
                className={classes.textField}
                variant="outlined"
                InputProps={{
                    inputComponent: InputComponent
                }}
                value={moment(values).format("YYYY-MM-DD")}
                InputLabelProps={{
                    className: classes.cssLabel,
                    shrink: true,
                }}
                validators={validators}
                errorMessages={[fieldRequired]}
            />
        </Grid>
    );
}

export default CustomDateField;
